import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Header, Button, Label, Icon, Dropdown } from 'semantic-ui-react'
import {
  loadAttendance,
  clearAttendance,
  deleteAttendanceHeader,
  deleteAttender,
  addAttender,
  updateAttendance,
  feedbacksPdfAttendanceRemove,
  pdfAttendanceRemove,
  pdfAttendanceNew
} from '../../common/attendances/actions'
import { Title, ConfirmModal, FindDriverModal, Field } from '../components'
import { AttendeesTable } from '../tables'
import { courseTypesFormated } from '../../common/config'
import { roles } from '../../common/config'
import {loadActiveUsers} from "../../common/users/actions";
import Alert from "../components/Alert";

const { Column, Row } = Grid

const getRecordIcon = (r) => {
  if (!!r.archived || r.state == 'ARCH') {
    return <Icon name="trash" color="red" size="large" />
  }
  else if (r.state == 'NEW' || r.state == 'PREV') {
    return <Icon name="tablet" color="orange" size="large" />
  }
  else {
    return <Icon name="edit" color="green" size="large" />
  }
}

const getRecordType = (r) => {
  if (!!r.archived || r.state == 'ARCH') {
    return 'blokována'
  }
  else if (r.state == 'NEW' || r.state == 'PREV') {
    return 'v přípravě'
  }
  else {
    return 'provedena'
  }
}

const getRecordTag = (r) => {
  if (!!r.archived || r.state == 'ARCH') {
    return <Label color="red" size="big">Koš</Label>
  }
  else if (r.state == 'NEW' || r.state == 'PREV') {
    return <Label color="orange" size="big">Plán</Label>
  }
  else {
    return <Label color="green" size="big">OK</Label>
  }
}

const getPdfDate = (a) => {
  if (a.pdf && a.pdf.length > 0) {
    if (a.pdfAt && a.pdfAt.length > 0) {
      return moment(a.pdfAt).format('D.M.YYYY H:mm')
    } else {
      return "Vytištěn"
    }
  } else {
    return "Negenerován"
  }
}

class AttendancePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { attenderToRemove: null, isFindDriverVisible: false, timetable: {rows: [], cols: [], driversUsed: []} }
    this.addAttender = this.addAttender.bind(this)
    this.removeAttender = this.removeAttender.bind(this)
    this.timetableAddTime = this.timetableAddTime.bind(this)
    this.timetableAddInstructor = this.timetableAddInstructor.bind(this)
    this.timetableRemoveInstructor = this.timetableRemoveInstructor.bind(this)
    this.timetableRemoveTime = this.timetableRemoveTime.bind(this)
    this.updateAttendanceDrivers = this.updateAttendanceDrivers.bind(this)
    this.setAttenderToRemove = (attender) => this.setState({ attenderToRemove: attender })
    this.clearAttenderToRemove = () => this.setState({ attenderToRemove: null })
    this.showFindDriver = () => this.setState({ isFindDriverVisible: true })
    this.hideFindDriver = () => this.setState({ isFindDriverVisible: false })
    this.handleDragOver = this.handleDragOver.bind(this)
    this.handleDragLeave = this.handleDragLeave.bind(this)
    this.handleDragStart = this.handleDragStart.bind(this)
    this.handleDrop = this.handleDrop.bind(this)
    this.genDriverDraggableEl = this.genDriverDraggableEl.bind(this)
    this.printPreview = this.printPreview.bind(this)
    this.timetableTimeChanged = this.timetableTimeChanged.bind(this)
    this.timetableInstructorChanged = this.timetableInstructorChanged.bind(this)
    this.sendSms = this.sendSms.bind(this)
    this.draggedEl = null

    const inte = setInterval(() => {
      if (this.props.attendance._id !== '') {
        clearInterval(inte)

        if (this.props.attendance.timetable.startsWith('{')) {
          this.setState({timetable: JSON.parse(this.props.attendance.timetable)})
        }
      }
    }, 100)


  }
  componentDidMount() {
    const { match, loadAttendance, loadActiveUsers, attendance } = this.props
    const { params } = match
	  this.props.clearAttendance()

    loadAttendance(params.attendance)
    loadActiveUsers({role: "INSTRUCTOR"})
  }
  componentWillUnmount() {
    this.props.clearAttendance()
  }

  addAttender(attender) {
    const { addAttender } = this.props
    addAttender(attender)
    this.updateAttendanceDrivers({ type: 'ADD', attender })
  }

  removeAttender() {
    const { attenderToRemove } = this.state
    const { deleteAttender, attenders } = this.props
    const index = attenders.findIndex(a => attenderToRemove._id === a._id)
    deleteAttender(index)
    this.updateAttendanceDrivers({ type: 'REMOVE', attender: attenderToRemove })
  }

  updateAttendanceDrivers({ type, attender }) {
    const { timetable } = this.state
    const { updateAttendance, attendance } = this.props

    const newTimetable = JSON.parse(JSON.stringify(timetable))

    let drivers = [].concat(attendance.drivers)
    switch (type) {
      case 'ADD': {
        drivers.push({ driver: attender._id })
        break
      }
      case 'REMOVE': {
        drivers = drivers.filter(d => d.driver._id !== attender._id)

        // zkontrolujeme, zda mazany ridic neni v planovaci jizd, pripadne ho odstranime

        const driverIdIdx = newTimetable.driversUsed.indexOf(attender._id)

        if (driverIdIdx > -1) {
          newTimetable.driversUsed.splice(driverIdIdx, 1)

          newTimetable.rows.forEach((row, i) => {
            row.drivers.forEach((driverId, j) => {
              if (driverId === attender._id) {
                newTimetable.rows[i].drivers[j] = ""
              }
            })
          })
        }

        break
      }
      // no default
    }
    updateAttendance(attendance._id, {drivers: drivers, timetable: JSON.stringify(newTimetable)})
  }

  onDelete() {
    if (window.confirm('Opravdu chcete blokovat tento plán ?')) {
      this.deleteAttendanceHeader(this.attendance._id)
      window.location = '/attendances'
    }
  }

  onPdfNew(e) {
    const { pdfAttendanceNew, attendance, viewer } = this.props
    e.preventDefault()
    if (attendance.pdf && attendance.pdf.length > 0 && !window.confirm('Nově generované pdf přepíše již uložené. Opravdu chcete pokračovat?')) {
      return;
    }
    pdfAttendanceNew(attendance._id)
    window.open('/api/v1/attendances/'+ attendance._id + '/pdf?token=' + viewer.tokens.access, '_blank')
  }

  onPdfGet(e) {
    const { loadAttendance, attendance, viewer } = this.props
    e.preventDefault()
    window.open('/api/v1/attendances/'+ attendance._id + '/pdf?token=' + viewer.tokens.access, '_blank')
	setTimeout(function(){loadAttendance(attendance._id);},3000);
  }

  onPdfRemove(e) {
	const { pdfAttendanceRemove, attendance } = this.props
	e.preventDefault()
    if (window.confirm('Opravdu chcete zahodit uložené pdf?')) {
		pdfAttendanceRemove(attendance._id)
    }
  }

  onPdfUpload(e) {
	const { attendance } = this.props
	e.preventDefault()
    window.location = '/attendpdf/' + attendance._id
  }

  onPdfFeedbacksGet(e) {
    const { loadAttendance, attendance, viewer } = this.props
    e.preventDefault()
    window.open('/api/v1/attendances/'+ attendance._id + '/feedbacks_pdf?token=' + viewer.tokens.access, '_blank')
    setTimeout(function(){loadAttendance(attendance._id);},3000);
  }

  printPreview(e) {
    const { attendance, viewer } = this.props
    e.preventDefault()
    window.open('/api/v1/attendances/'+ attendance._id + '/timetable_pdf?token=' + viewer.tokens.access, '_blank')
  }

  sendSms(e) {
    const { attendance, viewer } = this.props
    e.preventDefault()
    window.open('/api/v1/attendances/'+ attendance._id + '/timetable_send_sms?token=' + viewer.tokens.access, '_blank')
  }

  onPdfFeedbacksRemove(e) {
    const { feedbacksPdfAttendanceRemove, attendance } = this.props
    e.preventDefault()
    if (window.confirm('Opravdu chcete zahodit uložené pdf se zpětnými vazbami?')) {
      feedbacksPdfAttendanceRemove(attendance._id)
    }
  }

  onPdfFeedbacksUpload(e) {
    const { attendance } = this.props
    e.preventDefault()
    window.location = '/attendpdffeedbacks/' + attendance._id
  }

  timetableAddTime(e) {
    e.preventDefault()
    const { timetable } = this.state
    const { updateAttendance, attendance } = this.props

    const newRow = {
      time: `${new Date().toISOString().substring(0, 10)}T00:00`,
      drivers: []
    }

    console.log(timetable)

    timetable.cols.forEach(() => {
      newRow.drivers.push("")
    })

    const newTimetable = JSON.parse(JSON.stringify(timetable))
    newTimetable.rows.push(newRow)

    updateAttendance(attendance._id, {timetable: JSON.stringify(newTimetable)})

    this.setState({timetable: newTimetable})
  }

  timetableAddInstructor(e) {
    e.preventDefault()
    const { timetable } = this.state
    const { updateAttendance, attendance } = this.props

    const newCol = null
    const newTimetable = JSON.parse(JSON.stringify(timetable))
    newTimetable.cols.push(newCol)

    newTimetable.rows.forEach((row, i) => {
      newTimetable.cols.forEach((col, j) => {
        if (typeof newTimetable.rows[i].drivers[j] === "undefined") {
          newTimetable.rows[i].drivers.push("")
        }
      })
    })

    updateAttendance(attendance._id, {timetable: JSON.stringify(newTimetable)})

    this.setState({timetable: newTimetable})
  }

  timetableRemoveInstructor(e) {
    e.preventDefault()
    const { timetable } = this.state
    const { updateAttendance, attendance } = this.props

    const rmIdx = parseInt(e.target.dataset.idx)

    const newTimetable = JSON.parse(JSON.stringify(timetable))

    newTimetable.cols.splice(rmIdx, 1)
    newTimetable.rows.forEach((row, i) => {
      // pred smazanim bunky s ridicem vratime daneho ridice do vyberu
      const driverId = newTimetable.rows[i].drivers[rmIdx]

      if (driverId !== "") {
        const driverIdIdx = newTimetable.driversUsed.indexOf(driverId)
        newTimetable.driversUsed.splice(driverIdIdx, 1)
      }

      newTimetable.rows[i].drivers.splice(rmIdx, 1)
    })

    updateAttendance(attendance._id, {timetable: JSON.stringify(newTimetable)})

    this.setState({timetable: newTimetable})
  }

  timetableRemoveTime(e) {
    e.preventDefault()
    const { timetable } = this.state
    const { updateAttendance, attendance } = this.props

    const rmIdx = parseInt(e.target.dataset.idx)

    const newTimetable = JSON.parse(JSON.stringify(timetable))

    // pred smazanim radku vratime do vyberu vsechny ridice z daneho radku
    newTimetable.rows[rmIdx].drivers.forEach((driverId) => {
      if (driverId !== "") {
        const driverIdIdx = newTimetable.driversUsed.indexOf(driverId)
        newTimetable.driversUsed.splice(driverIdIdx, 1)
      }
    })

    newTimetable.rows.splice(rmIdx, 1)

    updateAttendance(attendance._id, {timetable: JSON.stringify(newTimetable)})

    this.setState({timetable: newTimetable})
  }

  handleDrop(e) {
    e.preventDefault()
    const { timetable } = this.state
    const { updateAttendance, attendance } = this.props

    e.target.style.backgroundColor = "transparent"

    const newTimetable = JSON.parse(JSON.stringify(timetable))
    const colIdx = parseInt(e.target.dataset.col)
    const rowIdx = parseInt(e.target.dataset.row)

    // nejaky ridic uz v dane bunce je, odebereme ho z ridicu, kteri nemaji byt na vyber, aby se objevil zpet v ridicich k vyberu
    if (newTimetable.rows[rowIdx].drivers[colIdx] !== "") {
      const currentDriveIdIdx = newTimetable.driversUsed.indexOf(newTimetable.rows[rowIdx].drivers[colIdx])
      newTimetable.driversUsed.splice(currentDriveIdIdx, 1)
    }

    newTimetable.rows[rowIdx].drivers[colIdx] = this.draggedEl.dataset.id

    // nove pridaneho ridice vlozime mezi pouzite ridice, aby se uz nezobrazoval mezi ridici k vyberu
    if (newTimetable.driversUsed.indexOf(this.draggedEl.dataset.id) < 0) {
      newTimetable.driversUsed.push(this.draggedEl.dataset.id)
    }

    // zkontrolujeme, zda neni stejny ridic jeste v jine bunce, pokud ano, smazeme ho
    newTimetable.rows.forEach((row, i) => {
      row.drivers.forEach((col, j) => {
        if (col === this.draggedEl.dataset.id && (i !== rowIdx || j !== colIdx)) {
          newTimetable.rows[i].drivers[j] = ""
        }
      })
    })

    updateAttendance(attendance._id, {timetable: JSON.stringify(newTimetable)})

    this.setState({timetable: newTimetable})
  }

  handleDragOver(e) {
    e.preventDefault()
    if (e.target.className === "dropzone") {
      e.target.style.backgroundColor = "#E7F3E7"
    }
  }

  handleDragLeave(e) {
    e.preventDefault()
    if (e.target.className === "dropzone") {
      e.target.style.backgroundColor = "transparent"
    }
  }

  handleDragStart(e) {
    this.draggedEl = e.target
  }

  genDriverDraggableEl(id) {
    const { attendance } = this.props
    const timetableDrivers = JSON.parse(attendance.timetableDrivers)

    const stringToColour = function(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      let colour = '#';
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xFF;
        colour += ('00' + value.toString(16)).substr(-2);
      }
      return colour;
    }

    for (let i = 0; i < timetableDrivers.length; i++) {
      const d = timetableDrivers[i]
      if (d._id === id) {
        const border = `1px solid ${stringToColour(d.companyName)}`
        console.log(border)
        return (<div key={i} draggable="true" className="driver" style={{border: border}} data-id={d._id} onDragStart={this.handleDragStart}>
          {d.firstName}&nbsp;{d.lastName}<br/>&nbsp;{d.phoneNumber}<br/>{d.companyName}</div>)
      }
    }

    return null
  }

  timetableTimeChanged(e) {
    const { timetable } = this.state
    const { updateAttendance, attendance } = this.props

    const newTimetable = JSON.parse(JSON.stringify(timetable))
    const idx = parseInt(e.target.dataset.i)
    let parts = timetable.rows[idx].time.split('T')

    if (e.target.type === 'date') {
      parts[0] = e.target.value
    }
    else if (e.target.type === 'time') {
      parts[1] = e.target.value
    }

    newTimetable.rows[idx].time = parts.join('T')

    updateAttendance(attendance._id, {timetable: JSON.stringify(newTimetable)})

    this.setState({timetable: newTimetable})
  }

  timetableInstructorChanged(e) {
    const { timetable } = this.state
    const { updateAttendance, attendance } = this.props

    const newTimetable = JSON.parse(JSON.stringify(timetable))
    const idx = parseInt(e.target.dataset.i)

    newTimetable.cols[idx] = e.target.value

    updateAttendance(attendance._id, {timetable: JSON.stringify(newTimetable)})

    this.setState({timetable: newTimetable})
  }

  render() {
    const { attendance, attenders, viewer, instructors} = this.props
    if (!attendance || !attendance._id) return <div />
    const { attenderToRemove, isFindDriverVisible, timetable } = this.state
    const title = `${moment(attendance.date).format('D.M.YYYY')} (${attendance.companyName}, ${attendance.locationName})`
    const pdfico = (attendance.pdf && attendance.pdf.length > 0) ? `download`  : `refresh`
    const timetableDrivers = JSON.parse(attendance.timetableDrivers)


    return (
      <div>
        <Title message={title} />
        <ConfirmModal
          message={attenderToRemove ? `Opravdu chcete smazat účastníka "${attenderToRemove.name}"?` : ''}
          onClose={this.clearAttenderToRemove}
          onConfirm={this.removeAttender}
        />
        <FindDriverModal
          open={isFindDriverVisible}
          onClose={this.hideFindDriver}
          onConfirm={this.addAttender}
          confirmMessage="Přidat účastníka"
          headerMessage="Přidat účastníka do prezenční listiny"
          ignoredDrivers={attenders.map(a => a._id)}
        />
        <aside className="breadcrumbs">
          <Link to="/attendances">Prezenční listiny</Link>
          <img src="/images/arrow.png" alt="arrow-right" />
          <span>{title}</span>
          <div className="options">
            <Dropdown text='PDF' button labeled icon='wrench' className='icon'>
              <Dropdown.Menu>
                <Dropdown.Header icon='file' content={getPdfDate(attendance)} />

                <Dropdown.Divider />

                <Dropdown.Item text='Prezenční listina:' onClick={(e) => {return false}} />
                {viewer.role !== 'FLEET_MANAGER' && attendance.pdf && attendance.pdf.length > 0 && <Dropdown.Item icon='refresh' text='Generovat' onClick={(e) => this.onPdfNew(e)} />}
                {attendance.pdf && attendance.pdf.length > 0 && <Dropdown.Item icon='download' text='Stáhnout' onClick={(e) => this.onPdfGet(e)} />}
                {viewer.role !== 'FLEET_MANAGER' && attendance.pdf && attendance.pdf.length > 0 && <Dropdown.Item icon='ban' text='Smazat' onClick={(e) => this.onPdfRemove(e)} />}
                {viewer.role !== 'FLEET_MANAGER' && !attendance.archived && attendance.state !== 'ARCH' && <Dropdown.Item icon='add' text='Vložit' onClick={(e) => this.onPdfUpload(e)} />}

                <Dropdown.Divider />

                <Dropdown.Item text='Zpětné vazby:' onClick={(e) => {return false}} />
                {attendance.feedbacksPdf && attendance.feedbacksPdf.length > 0 &&
                  <Dropdown.Item icon='download' text='Stáhnout' onClick={(e) => this.onPdfFeedbacksGet(e)} />}
                {[roles.SUPERVISOR, roles.ADMIN].indexOf(viewer.role) > -1 && attendance.feedbacksPdf && attendance.feedbacksPdf.length > 0 &&
                  <Dropdown.Item icon='ban' text='Smazat' onClick={(e) => this.onPdfFeedbacksRemove(e)} />}
                {[roles.SUPERVISOR, roles.ADMIN].indexOf(viewer.role) > -1 && !attendance.archived && attendance.state !== 'ARCH' &&
                  <Dropdown.Item icon='add' text='Vložit' onClick={(e) => this.onPdfFeedbacksUpload(e)} />}
              </Dropdown.Menu>
            </Dropdown>
            <Button onClick={(e) => this.onPdfGet(e)}><Icon name={pdfico} />Stáhnout PDF</Button>
            {!this.props.attendance.archived && [roles.SUPERVISOR, roles.ADMIN].indexOf(viewer.role) !== -1 &&
              <button onClick={this.onDelete.bind(this.props)}>Blokovat</button>
            }
          </div>
        </aside>

        <div className="content-wrapper">
          <Grid>
            <Row columns={2}>
              <Column className="w40p">
                <div className="form-page full">
                  <Grid>
                    <Row columns={1}>
                      <Column><Header as="h2">Základní údaje <Link to={`/attendheader/${attendance._id}`} style={{fontSize:'small',color:'red'}}>Změnit</Link></Header></Column>
                    </Row>
                    <Row columns={2}>
                      <Column>{getRecordIcon(attendance)} {getRecordType(attendance)}</Column>
                      <Column>{getRecordTag(attendance)}</Column>
                    </Row>
                    <Row columns={2}>
                      <Column>Dopravce: {attendance.companyName}</Column>
                      <Column>Kurz: {courseTypesFormated[attendance.courseType].name}</Column>
                    </Row>
                    <Row columns={2}>
                      <Column>Lokace: {attendance.locationName}</Column>
                      <Column>Datum: {moment(attendance.date).format('D.M.YYYY')}</Column>
                    </Row>
                    {attendance.feedbacksPdf && attendance.feedbacksPdf.length > 0 &&
                      <Row columns={1}>
                        <Column><Button color="red" onClick={(e) => this.onPdfFeedbacksGet(e)}><Icon name="comments outline"></Icon>&nbsp;Prohlédnout zpětné vazby účastníků</Button></Column>
                      </Row>
                    }
                    <Row columns={1}>
                      <Column><Icon name="user" color="black" />{attendance.instructorName}</Column>
                    </Row>
                    {('' + attendance.note).length > 0 &&
                      <Row columns={1}>
                        <Column style={{fontStyle:'italic',color:'gray'}}><Icon name="info" color="black" /> {attendance.note}</Column>
                      </Row>
                    }
                  </Grid>
                  <Grid>
                    <Row columns={1}>
                      <Column><Header as="h2">Účastníci</Header></Column>
                    </Row>
                    <Row columns={1}>
                      <Column>
                        <AttendeesTable
                          attendees={attenders}
                          attendance={attendance}
                          removeAttender={this.setAttenderToRemove}
                          viewer={viewer}
                        />
                      </Column>
                    </Row>
                    {viewer.role !== 'FLEET_MANAGER' &&
                      <Row columns={1}>
                        <Button onClick={this.showFindDriver}>Přidat účastníka</Button>
                      </Row>
                    }
                  </Grid>
                </div>
              </Column>
              {viewer.role !== 'FLEET_MANAGER' &&
              <Column className="w60p">
                <div className="form-page full">
                  <Grid>
                    <Row columns={1}>
                      <Column><Header as="h2">Plánovač jízd</Header></Column>
                    </Row>
                    <Row columns={1}>
                      <Column>
                        <Button onClick={this.timetableAddTime}><Icon name="plus" color="black" size="large" /> Přidat čas</Button>
                        <Button onClick={this.timetableAddInstructor}><Icon name="plus" color="black" size="large" /> Přidat instruktora</Button>

                        <div className="drivers-draggable">

                        {timetableDrivers.map(d => {
                          return (timetable.driversUsed.indexOf(d._id) === -1 && this.genDriverDraggableEl(d._id))
                        })}
                        </div>

                        <table className="attendance-timetable">
                          <thead>
                            <tr>
                              <td>&nbsp;</td>
                              {timetable.cols.map((instructorId, i) => {
                                return (<td key={i}>
                                  <select onChange={this.timetableInstructorChanged} data-i={i}>
                                    <option value="">---</option>
                                    {instructors.sort((a, b) => {
                                      return a.lastName > b.lastName ? 1 : -1;
                                    }).map((instructor, i) => {
                                      return (<option key={i} value={instructor._id} selected={instructorId === instructor._id}>{instructor.firstName}&nbsp;{instructor.lastName}</option>)
                                    })}
                                  </select>
                                  <Icon name="trash" color="red" title="Smazat sloupec" onClick={this.timetableRemoveInstructor} data-idx={i}></Icon>
                                </td>)
                              })}
                            </tr>
                          </thead>
                          <tbody>
                          {timetable.rows.map((row, i) => {
                            return (<tr key={i}>
                              <td className="ui form">
                                <input type="date" data-i={i} onChange={this.timetableTimeChanged} value={row.time.split('T')[0]}/>
                                <input type="time" data-i={i} onChange={this.timetableTimeChanged} value={row.time.split('T')[1]}/>
                                <Icon name="trash" color="red" title="Smazat řádek" onClick={this.timetableRemoveTime} data-idx={i}></Icon>
                              </td>
                              {row.drivers.map((driver, j) => {
                                return (<td key={j}>
                                  <div className="dropzone" data-row={i} data-col={j} onDragOver={this.handleDragOver}
                                       onDragLeave={this.handleDragLeave} onDrop={this.handleDrop}>
                                    {driver && this.genDriverDraggableEl(driver)}
                                  </div></td>)
                              })}
                            </tr>)
                          })}
                          </tbody>
                        </table>
                        {timetable.driversUsed.length < attenders.size && <Alert type={'warning'} message={'Někteří řidiči ještě nemají naplánovanou jízdu.'}></Alert>}
                        <br/><br/>
                        <Button color="red" onClick={this.sendSms}><Icon name="envelope" size="large" /> SMS</Button>
                        <Button color="red" onClick={this.printPreview}><Icon name="file pdf outline" size="large" /> Zobrazení k tisku</Button>
                      </Column>
                    </Row>
                  </Grid>
                </div>
              </Column>
              }
            </Row>
          </Grid>
        </div>
      </div>
    )
  }
}

AttendancePage.propTypes = {
  viewer: React.PropTypes.object.isRequired,
  match: React.PropTypes.object.isRequired,
  attendance: React.PropTypes.object.isRequired,
  attenders: React.PropTypes.object.isRequired,
  loadAttendance: React.PropTypes.func.isRequired,
  clearAttendance: React.PropTypes.func.isRequired,
  pdfAttendanceRemove: React.PropTypes.func.isRequired,
  pdfAttendanceNew: React.PropTypes.func.isRequired,
  addAttender: React.PropTypes.func.isRequired,
  deleteAttender: React.PropTypes.func.isRequired,
  updateAttendance: React.PropTypes.func.isRequired,
  deleteAttendanceHeader: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  attendance: state.attendances.current,
  attenders: state.attendances.attenders,
  viewer: state.users.viewer,
  instructors: state.users.all
}), {
  loadAttendance,
  clearAttendance,
  pdfAttendanceRemove,
  pdfAttendanceNew,
  addAttender,
  deleteAttender,
  updateAttendance,
  deleteAttendanceHeader,
  feedbacksPdfAttendanceRemove,
  loadActiveUsers
})(AttendancePage)



// WEBPACK FOOTER //
// ./src/browser/pages/Attendance.js